export enum MultiFactorErrorType {
  Unknown = 'Unknown',
  CodeExpired = 'CodeExpired',
  CreateChallenge404 = 'CreateChallenge404',
  InvalidPhone = 'InvalidPhone',
  InvalidSMS = 'InvalidSMS',
}
